import {Component, Input, OnInit} from '@angular/core';
import {AbstractComponent} from "@components";
import {Competitor, Country, Lookups, UserEvent} from "@model";
import {FormControl, FormGroup} from "@angular/forms";
import {NgbDateParserFormatter} from "@ng-bootstrap/ng-bootstrap";
import {alphabetical, email, max_length_100, max_length_45} from "@utility";
import {FooterService} from "@services";
import {Location} from "@angular/common";

@Component({
  selector: 'app-my-entry-personal-info',
  templateUrl: './my-entry-personal-info.component.html',
  styleUrl: './my-entry-personal-info.component.scss',
  standalone: false
})
export class MyEntryPersonalInfoComponent extends AbstractComponent implements OnInit{
  @Input() userEvent: UserEvent | undefined;
  @Input() languages: Lookups[] = [];
  @Input() countries: Country[] = [];
  @Input() genders: Lookups[] = [];

  competitor: Competitor | undefined;
  currentDate: Date = new Date();
  activeEditCountValue: number = 0;
  editStates: { [key: string]: boolean } = {};

  inputForm = new FormGroup({
    firstname: new FormControl(),
    lastname: new FormControl(),
    email: new FormControl(),
    gender: new FormControl(),
    birthDay: new FormControl(),
    club: new FormControl(),
  });

  constructor(public formatter: NgbDateParserFormatter, private footerService: FooterService, private location: Location) {
    super();
  }

  ngOnInit(): void {
    if(this.userEvent) {
      this.competitor = this.userEvent?.competitor;
    }

    this.initForm();
    this.updateFooter()
  }

  private initForm() {
    this.inputForm.controls.firstname.addValidators([max_length_45, alphabetical]);
    this.inputForm.controls.lastname.addValidators([max_length_45, alphabetical]);
    this.inputForm.controls.email.addValidators([email]);
    this.inputForm.controls.club.addValidators([max_length_100]);
  }

  get activeEditCount(): number {
    return this.activeEditCountValue;
  }

  onEdit(fieldName: string): void {
    if (!fieldName) return;

    this.editStates[fieldName] = !this.editStates[fieldName];
    this.calculateActiveEdits();
    this.updateFooter();
  }

  private calculateActiveEdits(): void {
    if (!this.editStates) {
      this.activeEditCountValue = 0;
      return;
    }
    this.activeEditCountValue = Object.values(this.editStates).filter(state => !!state).length;
  }

  private updateFooter(): void {
    setTimeout(() => {
      this.footerService.update({
        activeEditCount: (this.activeEditCountValue || 0).toString()
      });
    });
  }

  goBack() {
    if (this.location) {
      this.location.back();
    }
  }

  //TODO
  onSubmitCorrection(): void {

  }
}
